import React, { useState, useEffect } from 'react'
import { fetchSidebarData } from '../Apis/apis';

function Navbar() {

  const [sidebarPrivalages, setsidebarPrivalage] = useState(null);
  const LOCAL_URL = window.location.origin;

  const requestData = async () => {

    if (localStorage.getItem("sidebarData") != null) {

      const data = JSON.parse(localStorage.getItem("sidebarData")).data;
      setsidebarPrivalage(data);


    } else {

      const sidebarPrivalages = await fetchSidebarData();
      const newSidebar = sidebarPrivalages.privileges.filter(object => {
        return object.group !== "LEGACY";
      });

      localStorage.setItem('sidebarData', JSON.stringify({
        data: newSidebar
      }));

      setsidebarPrivalage(newSidebar);
    }

  }
  useEffect(() => {

    requestData();
  }, []);

  return (
    <div className="main-sidebar scrollbar">
      <nav id="sidebar">
        <div className="sidebar-header">
          <img alt='logo' src={`${LOCAL_URL}/images/admin-logo.png`} />
        </div>


        <ul key={'nav'} className="list-unstyled components side-scroll">

          {/* FIX UL LIST  */}
          <>


            {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'DASHBOARD') ?


              <li>
                <a href="#/Dashboard">
                  <i className="fa-brands fa-windows" /> Dashboard{" "}
                </a>
              </li>
              : ''}
            {/* Category    */}
            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === 'CATEGORY') ?
              <li>
                <a href="#/CATEGORIES">
                  <i className="fa-brands fa-windows" />CATEGORIES
                </a>
              </li>
              : ''}

            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === 'FINANCE') ?
              <li>
                <a
                  href="#FINANCE"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fas fa-id-card-alt" /> FINANCE{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="FINANCE">
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'RECEIPTS') ?

                    <li>
                      <a href="/#/Receipts">Receipts</a>
                    </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'PAYMENTS') ?
                    <li>
                      <a href="#/Payment">Payments</a>
                    </li> : ''}
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'GST_INVOICES') ?
                    <li>
                      <a href="#/GstInvoiceFromKisan">Gst invoices</a>
                    </li> : ''}

                  <li>
                    <a href="#/All-Finance">All-Finance</a>
                  </li>
                </ul>
              </li>
              : ''}


            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === 'PACKAGE') ?
              <li>
                <a
                  href="#PACKAGE"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fas fa-gift" /> PACKAGE{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="PACKAGE">

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'FREE_PACKAGE') ?
                    <li>
                      <a href="/#/PACKAGES_FREE">Free package</a>
                    </li> : ''}
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'GENERAL_PACKAGE') ? <li>
                    <a href="#/PACKAGES_GENERAL">Genral package</a>
                  </li> : ''}
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'DEALER_PACKAGE') ? <li>
                    <a href="#/PACKAGES_DEALER">Dealer package</a>
                  </li> : ''}
                </ul>
              </li>
              : ''}
            {/* APPROVALS */}

            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === 'APPROVAL') ?
              <li>
                <a
                  href="#APPROVALS"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fas fa-clipboard-check" /> APPROVALS{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="APPROVALS">


                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'DEALER_ON_BOARDING_APPROVALS') ? <li>
                    <a href="/#/OBA/DealerApprovals">On-Boarding Approvals</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'GENERAL_POSTING_APPROVALS') ? <li>
                    <a href="#/POSTINGS/GEN/PENDING_FOR_APPROVAL">POSTINGS APPROVELS</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'REVIEW_AND_RATING') ? <li>
                    <a href="#/REVIEW_APPROVE">Review & rating Approvals</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'PUSH_NOTIFICATION_ADMIN_APPROVAL') ? <li>
                    <a href="/#/NOTIFICATION">Notifications Approvals</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'PUSH_NOTIFICATION_ADMIN_APPROVAL') ? <li>
                    <a href="/#/NOTIFICATION-Review">Notifications Review</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'PUSH_NOTIFICATION_ADMIN_APPROVAL') ? <li>
                    <a href="/#/BannerApprovals">Banner  Approvals</a>
                  </li> : ''}

                  <li>
                    <a href="/#/User/Farmers">All Users</a>
                  </li>
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'DEALER_ON_BOARDING_APPROVALS') ? <li>
                    <a href="/#/Lead/DealerLeads">All Lead</a>
                  </li> : ''}
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'DEALER_ON_BOARDING_APPROVALS') ? <li>
                    <a href="/#/Milk/Collection">Milk Collection</a>
                  </li> : ''}

                  <li>
                    <a href="#/Unconfirmed-Users">Unconfirmed Users</a>
                  </li>

                </ul>
              </li>
              : ""}

            {/* ADMIN USER */}
            {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'CREATE_POSITION' || e.name === 'ADMIN_LIST') ?
              <li>
                <a
                  href="#USER"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fas fa-user-check" /> ADMIN USER{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="USER">
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'CREATE_POSITION') ? <li>
                    <a href="/#/POSITION">POSITION</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'CREATE_POSITION') ? <li>
                    <a href="#/AddUser">Add User</a>
                  </li> : ''}

                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'ADMIN_LIST') ? <li>
                    <a href="#/Users">Admin List</a>
                  </li> : ''}



                </ul>
              </li>
              : ''
            }


            {/* ADMIN POSTINGS */}

            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === "ADMIN_POSTING") ?
              <li>
                <a
                  href="#POSTINGS"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fas fa-th" /> ADMIN POSTINGS{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="POSTINGS">



                  <li>
                    <a href="/#/CHOOSE-NOTIFICATION">Push notifications</a>
                  </li>
                  <li>
                    <a href="/#/MobileBanner">Banner Posting</a>
                  </li>
                  <li>
                    <a href="/#/NewsEvents">News & Events</a>
                  </li>

                </ul>
              </li>
              : ''}

            {/* ADMIN APPROVALS */}

            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === "ADMIN_TRANSLATOR") ?


              <li>
                <a
                  href="#TRANSLATOR"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="far fa-file-alt" /> ADMIN TRANSLATOR{" "}
                </a>
                <ul className="collapse list-unstyled sub-menu" id="TRANSLATOR">
                  <li>
                    <a href="/#/MASTERS">MASTERS</a>
                  </li>
                </ul>
              </li>
              : ''}

            {/* SETTINGS */}
            {sidebarPrivalages && sidebarPrivalages.some(e => e.name === 'NOTIFICATION_SETTING' || e.name === 'AGENT_COMMISSION_SETTING') ?
              <li>
                <a
                  href="#SETTINGS"
                  data-bs-toggle="collapse"
                  aria-expanded="false"
                  className="dropdown-toggle"
                >
                  <i className="fa-solid fa-gear" /> SETTINGS
                </a>
                <ul className="collapse list-unstyled sub-menu" id="SETTINGS">
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === "NOTIFICATION_SETTING") ? <li>
                    <a href="/#/Notification-Setting">Notification settings</a>
                  </li> : ''}

                  <li>
                    <a href="/#/PRICE-SETTINGS">Price settings</a>
                  </li>

                  <li>
                    <a href="/#/Lead-Price-Setting">Lead Price settings</a>
                  </li>

                  
                  {sidebarPrivalages && sidebarPrivalages.some(e => e.name === "AGENT_COMMISSION_SETTING") ? <li>
                    <a href="/#/AGENT-SETTINGS">Agent commision  settings</a>
                  </li> : ''}
                </ul>
              </li>
              : ''}


            {sidebarPrivalages && sidebarPrivalages.some(e => e.group === "MIS_REPORT") ?
              <li>
                <a href="#/MIS_REPORT">
                  <i className="fas fa-project-diagram" /> Mis Report
                </a>
              </li>
              : ''}

            {/* <li>
              <a href="#">
                <i className="fa-brands fa-windows" />USER LIST-ALL
              </a>
            </li>

            <li >
              <a href="#">
                <i className="fa-brands fa-windows" />USER REFFRALS
              </a>
            </li> */}

          </>

        </ul>
      </nav>
    </div>
  )
}
export default Navbar